<template>
    <form @submit.prevent="submit">
        <hox-input
            ref="sectionName"
            :model-value="internalFormData.name"
            is-required
            placeholder="E.g. Branding Q1"
            data-testid="add-section-modal__name-input"
            :show-error="validationErrors.name !== undefined"
            @input="internalFormData.name = $event"
        >
            <template #label>Section name</template>
            <template #error>
                <p v-for="error in validationErrors.name" :key="error">
                    {{ error }}
                </p>
            </template>
        </hox-input>
    </form>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        initialFormData: {
            type: Object
        }
    },

    emits: ["formDataUpdate", "hasValidationErrorsUpdate", "submit"],

    data() {
        return {
            internalFormData: { ...this.initialFormData }
        };
    },

    computed: {
        hasValidationErrors() {
            return Object.keys(this.validationErrors).length > 0;
        },

        validationErrors() {
            const errors: Record<string, string[]> = {};

            if (this.internalFormData.name !== undefined && !this.internalFormData.name.trim()) {
                errors.name = ["Section name is required and cannot be empty."];
            }

            return errors;
        }
    },

    watch: {
        hasValidationErrors: {
            handler() {
                this.$emit("hasValidationErrorsUpdate", this.hasValidationErrors);
            },
            immediate: true
        },

        internalFormData: {
            deep: true,
            handler() {
                this.$emit("formDataUpdate", { ...this.internalFormData });
            },
            immediate: true
        }
    },

    async mounted() {
        await this.$nextTick();
        (this.$refs.sectionName as HTMLInputElement)?.focus();
    },

    methods: {
        submit() {
            this.$emit("submit", { ...this.internalFormData });
        }
    }
});
</script>

<style lang="scss">
@use "@style/variables" as *;
</style>
